<template>
    <div class="panel nps-adherence">
        <h4 class="panel-title">Avaliações de NPS (Adesão Regional)</h4>
        <hr />

        <div class="nps-table">
            <div v-for="(item, index) in npsData" :key="index" class="nps-row">
                <span class="label">{{ item.descricao }}</span>
                <div class="stars">
                    <span v-for="starIndex in 5" :key="starIndex" class="star"
                        :class="{ filled: starIndex <= item.nota }">★</span>
                </div>
                <span class="value">{{ item.quantidade }}</span>
            </div>

            <hr class="divider" />

            <div class="nps-total">
                <span class="label">Total de Avaliadas:</span>
                <span class="value">{{ totalAvaliadas }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NpsPanel",
    props: {
        panelData: {
            type: Object,
            required: true
        }
    },
    computed: {
        npsData() {
            return this.panelData.categorias_avaliacoes
        },
        totalAvaliadas() {
            return this.panelData.total_avaliacoes
        }
    }
}
</script>

<style scoped>
.nps-table {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.nps-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
}

.nps-row .label {
    flex: 1;
    color: #5e5873;
}

.stars {
    display: flex;
    gap: 2px;
    flex: 0 0 100px;
}

.star {
    font-size: 18px;
    color: #bad2eb;
}

.star.filled {
    color: #2772c0;
}

.value {
    width: 40px;
    text-align: right;
    font-weight: 600;
    color: #5e5873;
}

.divider {
    margin: 8px 0;
}

.nps-total {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    color: #5e5873;
    margin-top: 4px;
}

.general-data.row-1:has(.panel:nth-child(5)) .nps-adherence {
    .nps-table {
        gap: 2px;
    }

    .stars{
        flex: 0 0 80px;
    }
}

</style>
